import React, { useEffect, useState } from "react";
import { toast } from "react-toastify";

const Contact = () => {
  const [contacts, setContacts] = useState([]);
  const [isLoading, setIsLoading] = useState(true); // State to track loading

  useEffect(() => {
    // Make an API request to fetch contact data when the component mounts
    const fetchData = async () => {
      try {
        const res = await fetch(
          "https://fine-cyan-chipmunk-shoe.cyclic.app//api/getallcontact",
          {
            method: "GET", // Use GET method for retrieving data
          }
        );

        if (res.status === 200) {
          const data = await res.json();
          setContacts(data.data); // Update the state with the retrieved data
        } else {
          // Handle error, show a message, etc.
          console.error("API Error:", res.statusText);
        }
      } catch (error) {
        console.error("API Error:", error);
      } finally {
        setIsLoading(false); // Set loading state to false when the API call is done
      }
    };

    fetchData();
  }, []); // The empty dependency array ensures the effect runs once when the component mounts

  return (
    <div className="dash_contact">
      <div className="dash_contact_head">
        <h3>Name</h3>
        <h3>Email</h3>
        <h3>MobileNO</h3>
        <h3>Message</h3>
      </div>
      {isLoading ? (
        <p>Loading...</p> // Display a loading indicator while loading
      ) : (
        contacts?.map((contact, index) => (
          <div className="dash_contact_body " key={index}>
            <p>{contact.name}</p>
            <p>{contact.email}</p>
            <p>{contact.phoneNumber}</p>
            <p style={{ maxWidth: "400px" }}>{contact.message}</p>
          </div>
        ))
      )}
    </div>
  );
};

export default Contact;
